export const ESITO_LABEL: Record<string, string> = {
  POSITIVO: 'Positivo',
  NEGATIVO: 'Negativo',
  NEUTRO: 'Neutro',
  ANNULLATA: 'Annullata',
};

export const ESITO_COLOR: Record<string, string> = {
  POSITIVO: '#4caf50',
  NEGATIVO: '#ef4444',
  NEUTRO: '#f59e0b',
  ANNULLATA: '#6c757d',
};

export const esitoLabel = (esito?: string | null): string =>
  esito ? (ESITO_LABEL[esito] ?? esito) : '';
